<template>
    <div class="filter-configs flex-center">
        <template v-for="(item, key) in formatFilterConfigs">
            <!-- 普通单选，多选下选框 -->
            <el-popover
                :ref="`filter_popover`"
                popper-class="filter-config-popover"
                placement="bottom"
                :width="item.width ?? '168'"
                trigger="hover"
                :key="key"
                @show="popoverIcon[item.key] = true"
                @hide="popoverIcon[item.key] = false"
                v-if="['single-select', 'multiple-select', 'multiple-level-select'].includes(item.type)"
            >
                <!-- 普通选择 -->
                <div class="select-popover" v-if="['single-select', 'multiple-select'].includes(item.type)">
                    <div
                        :class="['select-item ellipsis-single flex-center', { active: isActive(item.type, item.key, option.value) }]"
                        v-for="option in item.options"
                        :key="option.value"
                        @click="handleSelect(item.key, item.type, option)"
                    >
                        {{ option.label }}

                        <i class="el-icon-check" v-if="isActive(item.type, item.key, option.value)"></i>
                    </div>
                </div>

                <!-- 公司行业 -->
                <div class="select-popover industry" v-if="item.type === 'multiple-level-select'">
                    <div class="industory-item" v-for="option in item.options" :key="option.value">
                        <span class="label ellipsis-single">{{ option.label }}</span>

                        <div class="select-list">
                            <div
                                :class="['select-item ellipsis-single flex-center', { active: isActive(item.type, item.key, child.value) }]"
                                v-for="child in option.children"
                                :key="child.key"
                                @click="handleSelect(item.key, item.type, child)"
                            >
                                {{ child.label }}

                                <i class="el-icon-check" v-if="isActive(item.type, item.key, child.value)"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div :class="['filter-item', { active: !isEmpty(filters[item.key]) || popoverIcon[item.key] }]" slot="reference">
                    {{ item.label }}

                    <template v-if="!isEmpty(filters[item.key])">
                        ({{ item.type === "single-select" ? 1 : filters[item.key]?.length }})
                    </template>

                    <i class="iconfont">
                        {{ popoverIcon[item.key] ? "&#xe76d;" : "&#xe771;" }}
                    </i>
                </div>
            </el-popover>

            <!-- 城市 -->
            <div :class="['filter-item city active']" v-else-if="item.type === 'city-check'" :key="item.key" @click="cittVisible = true">
                <i class="el-icon-location"></i>

                {{ !isEmpty(filters[item.key]) ? filters[item.key] : "全国" }}
            </div>
        </template>

        <CityCheckDialog v-model="cittVisible" :check="filters.city ?? ''" @check="handleCheckCity"></CityCheckDialog>
    </div>
</template>

<script>
import industryJSON from "@/json/industry.json";
import { isEmpty } from "@/utils/common.js";
import CityCheckDialog from "./CityCheckDialog.vue";

export default {
    data() {
        return {
            // icon状态
            popoverIcon: {
                job_type: false,
                salary: false,
                experience: false,
                degree: false,
                industry: false,
                staff_size: false,
            },

            // 过滤参数
            filterConfigs: {
                city: {
                    label: "工作城市",
                    key: "city",
                    type: "city-check",
                },

                job_type: {
                    label: "求职类型",
                    key: "job_type",
                    type: "single-select",
                    options: [
                        { label: "不限", value: 0 },
                        { label: "全职", value: 1 },
                        { label: "兼职", value: 2 },
                    ],
                },

                salary: {
                    label: "薪资待遇",
                    key: "salary",
                    type: "single-select",
                    options: [
                        { label: "不限", value: "不限" },
                        { label: "3k以下", value: "3k以下" },
                        { label: "3-5k", value: "3-5k" },
                        { label: "5-10k", value: "5-10k" },
                        { label: "10-20k", value: "10-20k" },
                        { label: "20-50k", value: "20-50k" },
                        { label: "50k以上", value: "50k以上" },
                    ],
                },

                experience: {
                    label: "工作经验",
                    key: "experience",
                    type: "multiple-select",
                    options: [
                        { label: "不限", value: "不限" },
                        { label: "在校生", value: "在校生" },
                        { label: "应届生", value: "应届生" },
                        { label: "经验不限", value: "经验不限" },
                        { label: "1年以内", value: "1年以内" },
                        { label: "1-3年", value: "1-3年" },
                        { label: "3-5年", value: "3-5年" },
                        { label: "5-10年", value: "5-10年" },
                        { label: "10年以上", value: "10年以上" },
                    ],
                },

                degree: {
                    label: "学历要求",
                    key: "degree",
                    type: "multiple-select",
                    options: [
                        { label: "不限", value: "不限" },
                        { label: "初中及以下", value: "初中及以下" },
                        { label: "中转/中技", value: "中转/中技" },
                        { label: "高中", value: "高中" },
                        { label: "大专", value: "大专" },
                        { label: "本科", value: "本科" },
                        { label: "硕士", value: "硕士" },
                        { label: "博士", value: "博士" },
                    ],
                },

                industry: {
                    label: "公司行业",
                    key: "industry",
                    type: "multiple-level-select",
                    width: 680,
                    options: industryJSON,
                },

                staff_size: {
                    label: "公司规模",
                    key: "staff_size",
                    type: "multiple-select",
                    options: [
                        { label: "不限", value: "不限" },
                        { label: "0-20人", value: "0-20人" },
                        { label: "20-99人", value: "20-99人" },
                        { label: "100-499人", value: "100-499人" },
                        { label: "500-999人", value: "500-999人" },
                        { label: "1000-9999人", value: "1000-9999人" },
                        { label: "10000人以上", value: "10000人以上" },
                    ],
                },
            },

            // 过滤数值
            filters: {
                city: undefined,
                job_type: undefined,
                salary: undefined,
                experience: [],
                degree: [],
                industry: [],
                staff_size: [],
            },

            cittVisible: false, // 选择城市弹框visible
        };
    },

    props: {
        keys: {
            type: String,
        },
    },

    computed: {
        formatFilterConfigs() {
            if (!this.keys || typeof this.keys !== "string") return this.filterConfigs;

            const keyArr = this.keys.split(",");
            const configs = {};
            keyArr.forEach((key) => (configs[key] = this.filterConfigs[key]));

            return configs;
        },
    },

    components: {
        CityCheckDialog,
    },

    methods: {
        isEmpty(value) {
            return isEmpty(value);
        },

        isActive(type, key, value) {
            if (type === "single-select") {
                return this.filters[key] === value;
            } else {
                return this.filters[key]?.includes(value);
            }
        },

        // 数值是否发生改变
        isChange(prev, cur) {
            if (!prev || typeof prev === "string" || typeof prev === "number") {
                return prev !== cur;
            }

            if (Array.isArray(prev)) {
                if (prev.length !== cur.length) return true;

                const prevSet = new Set(prev);
                const curSet = new Set(cur);

                if (prevSet.size !== curSet.size) return true;

                for (const item of prevSet) {
                    if (!curSet.has(item)) return true;
                }

                return false;
            }
        },

        // 选择城市
        handleCheckCity(val) {
            this.filters.city = val.value === "全国" ? undefined : val.value;
            this.$emit("change", this.filters);
        },

        // 清空
        clear() {
            const cur = {
                city: undefined,
                job_type: undefined,
                salary: undefined,
                experience: [],
                degree: [],
                industry: [],
                staff_size: [],
            };

            let change = false;
            for (let key in cur) {
                if (this.isChange(this.filters[key], cur[key])) {
                    change = true;
                    break;
                }
            }

            this.filters = cur;

            if (change) this.$emit("change", this.filters);
        },

        // 选择
        handleSelect(key, type, option) {
            if (type === "single-select") {
                this.$refs.filter_popover?.forEach((item) => {
                    item.doClose?.();
                });
            }

            let cur;
            if (option.value === "不限" || option.value === 0) {
                cur = type === "single-select" ? undefined : [];
            } else {
                if (type === "single-select") {
                    cur = this.filters[key] === option.value ? undefined : option.value;
                } else {
                    const set = new Set(this.filters[key]);
                    set[set.has(option.value) ? "delete" : "add"]?.(option.value);
                    cur = Array.from(set);
                }
            }

            const change = this.isChange(this.filters[key], cur);
            this.filters[key] = cur;

            if (change) this.$emit("change", this.filters);
        },
    },
};
</script>

<style lang="scss" scoped>
.filter-configs {
    gap: 8px;

    .filter-item {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background-color: #ffffff;
        padding-inline: 8px;
        border-radius: 4px;
        line-height: 20px;
        cursor: pointer;

        &.city {
            gap: 0px;
        }

        .iconfont {
            font-size: 8px;
            color: #cccccc;
        }

        .el-icon-location {
            font-size: 16px;
            line-height: 20px;
        }

        &.active {
            color: #685ef5;

            .iconfont {
                color: #685ef5;
            }
        }
    }
}
</style>

<style lang="scss">
.filter-config-popover {
    padding: 0;

    * {
        box-sizing: border-box;
    }

    .popper__arrow {
        display: none;
    }

    .select-popover {
        padding: 4px 8px;
        overflow: auto;

        &.industry {
            height: 294px;

            .industory-item {
                display: flex;

                .label {
                    display: inline-block;
                    width: 182px;
                    color: #222;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 20px;
                    padding: 8px 8px 8px 8px;
                }

                .select-list {
                    flex: 1;
                    min-width: 0;
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                }
            }
        }

        .select-item {
            min-width: 0;
            padding: 8px 8px 8px 8px;
            font-size: 14px;
            line-height: 20px;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.2s linear;
            justify-content: space-between;
            color: #333;

            .el-icon-check {
                font-weight: bold;
                color: #685ef5;
            }

            &.active {
                color: #685ef5;
            }

            &:hover {
                color: #685ef5;
                background-color: rgba(104, 94, 245, 0.1);
            }
        }
    }
}
</style>
